/**
* @name APP u-Planning
* @autor over.martinez@u-planner.com
* @description
* Descripcion del controlador
* @controller 
* # name: chartsDetailsCtrl
* # alias: cDetails
*/
import statesList from '../states_list.json';
export default class chartsDetailsCtrl {

	constructor($scope, $state, $stateParams, ngNotify, $timeout, UserInfoConstant, strategicTrackingListSrv, uiGridConstants, $location, $cookies) {
		this.$scope = $scope;
		this.$state = $state;
		this.$timeout = $timeout;
		this.ngNotify = ngNotify;
		this.$stateParams = $stateParams;
		this.services = strategicTrackingListSrv;
		this.userinfo = null;
		this.$cookies = $cookies;
		this.chartConfig = {};
		this.plans = [];
		this.states = [];
		this.state = null;
		this.plan = [];
		this.$location = $location;
		this.pageTitle = {
			"2": "Docencia", 
			"3": "Gestión Académica", 
			"4": "Extensión", 
			"5": "Consolidación del Cuerpo Profesoral", 
			"6": "Investigación", 
			"0": "Vista General"
		}
		this.globalParams = {
			idModule: this.$stateParams.idModule,
			idAcaUnit: this.$stateParams.acaUnit, 
		}
		this.globalParamsDt = {
			idModule: this.$stateParams.idModule,
			idAcaUnit: this.$stateParams.acaUnit, 
		}
		this.defineUiGrid(uiGridConstants);
		this.columnColors = "#433275,#3ab6ce,#45739d,#bd2f71,#4082b9".split(',');
		this.$scope.UserInfoConstant = UserInfoConstant;
		this.$scope.$watch('UserInfoConstant[0].details[0]', (details, before) => {
			if (details !== undefined) {
				this.userinfo = details.user;
				this.globalParams.userId = this.userinfo.id;
				this.globalParams.roleId = this.$cookies.get('hasRoleId');
				this.userinfo.roleId = this.globalParams.roleId
				this.moduleName = this.pageTitle[this.$stateParams.idModule];
				this.main();
			}
		});

	}

	main() {
		this.checkRole();
		if (this.$stateParams.idModule == 0) {
			this.getSummaryActivities()
		}
	}

	getSummaryActivities() {
		let params = {
			evaluatorId: this.userinfo.id,
			roleId: this.userinfo.roleId,
			academic_unit: this.$stateParams.acaUnit
		}
		this.services.tracking.getSummaryActivities(params).$promise.then((response) => {
			if (!response.status) {
				this.ngNotify.set('Ocurrio un error en el servicio', 'warn');
			} else {
				this.summaryActivities = response.data[0];
			}
		}, (err) => {
			this.ngNotify.set('Imposible conectar con el servicio', 'error');
		});
	}

	checkRole() {
		this.services.get.typeRole({roleId: this.globalParams.roleId}).$promise.then((response) => {
			if (!response.status) {
				this.ngNotify.set('Ocurrio un error en el servicio', 'warn');
			} else {
				this.role = response.data[0];
				if (this.role.types != 'TEACHER') {
					this.getPlans(() => {

						this.states = statesList.data;
						for (let i in this.states) {
							if (this.states[i].id_code == this.$stateParams.stateId) {
								this.state = this.states[i];
							}
						}
						
						this.getDataGrid();

					});
				}
			}
		}, (err) => {
			this.ngNotify.set('Imposible conectar con el servicio', 'error');
		});
	}

	getPlans(callback) {
		let params = {
			evaluatorId: this.userinfo.id,
			submoduleId: this.$stateParams.idModule,
			roleId: this.userinfo.roleId, 
		}
		this.services.tracking.plansByEvaluator(params).$promise.then((response) => {
			if (!response.status) {
				this.ngNotify.set('Ocurrio un error en el servicio', 'warn');
			} else {
				this.plans = response.data;
				let wid_params = (this.$stateParams.workplanId !== undefined) ? this.$stateParams.workplanId.split('-') : [0];
				for (let i in this.plans) {
					for (let x in wid_params) {
						if (this.plans[i].workplanId == wid_params[x]) {
							this.plan.push(this.plans[i])
						}
					}
				}
				callback();
			}
		}, (err) => {
			this.ngNotify.set('Imposible conectar con el servicio', 'error');
		});
	}

	getDataGrid() {
		this.globalParamsDt.userId=this.globalParams.userId;
		this.globalParamsDt.roleId=this.globalParams.roleId;
		this.globalParamsDt.planId=(this.plan.length > 0)?this.plan.map((plan) => {return plan.workplanId}):0;
		this.globalParamsDt.stateId=(this.state!=null)?this.state.id_code:0;
		if (this.plan.length == 1) {this.globalParamsDt.planId.push(0) }

		this.services.data.getDataGrid(this.globalParamsDt).$promise.then((response) => {
			if (!response.status) {
				this.ngNotify.set('Ocurrio un error en el servicio', 'warn');
			} else {
				if (this.role.types == 'TEACHER') {
					this.goToDetails(response.data[0]);
				} else {
					this.gridOptions.data = response.data;
					if (this.chartConfig.loading != undefined) {
						this.chartConfig.loading = true;
					}
					this.getDataChart()
				}
			}
		}, (err) => {
			this.ngNotify.set('Imposible conectar con el servicio', 'error');
		});
	}

	getDataChart() {
		let services = this.getChartService()
		services(this.globalParamsDt).$promise.then((response) => {
			if (!response.status) {
				this.ngNotify.set('Error al conectar con el servicio', 'warn');
			} else {
				this.buildCharts(response.data);
			}
		}, (err) => {
			this.ngNotify.set('Imposible conectar con el servicio', 'error');
		});
	}

	getChartService() {
		if (this.globalParams.idModule == '0') {
			return this.services.chart.getDataChartTotal;
		} else {
			return this.services.data.getDataChart;
		}
	}

	buildCharts(data) {
		let conf = {
			options: {chart: {type: "column"}, legend: {enabled: true } },
			series: [],
			title: {text: data.nombre || 'Vista general',style: {color: '#4f73d9',font: '18px Arial'}},
			xAxis: {
				title: {text: ''},
				labels:{enabled: false}
			},
			yAxis: {title: {text: ""} },
			loading: false,
			size: {height: "420", }
		}

		for (let x in data.state) {
			conf.series.push({
				data: [data.state[x].cantidad],
				name: data.state[x].ds_name,
				borderRadius: "5", 
				color: this.columnColors[x],
			});
		}
		this.chartConfig = conf;
	}

	goToDetails(item) {
		let plansId = this.plan.map(function(plan) {
			return plan.workplanId;
		}).reduce((before, current) => {
			let val = (before !== '') ? before + '-' : '';
			return val + current.toString()
		},'')
		let urls = {
			"2": "strategicTracking.strategicTrackingTeacherDetails", 
			"3": "strategicTracking.strategicTrackingAcadManagementDetails", 
			"4": "strategicTracking.strategicTrackingExtensionDetails", 
			"5": "strategicTracking.strategicTrackingConsolidationDetails", 
			"6": "strategicTracking.strategicTrackingInvestigationDetails", 
			"0": "strategicTracking.strategicTrackingGlobalViewDetails", 
		}
		this.globalParams.teacherId = item.id_teacher;
		this.globalParams.acaUnit = item.id_acadunit;

		if(this.$stateParams.idModule === 0)
		{
			this.globalParams.idModule = 2;
		}
		else
		{
			this.globalParams.idModule = this.$stateParams.idModule;
		}

		this.globalParams.workplanId = (plansId.length > 0) ? plansId : undefined;
		this.globalParams.stateId = (this.state != null) ? this.state.id_code : undefined;

		this.$state.go(urls[this.globalParams.idModule], this.globalParams);
	}

	reloadStage() {
		let plansId = this.plan.map(function(plan) {
			return plan.workplanId;
		}).reduce((before, current) => {
			let val = (before !== '') ? before + '-' : '';
			return val + current.toString()
		},'')

		let params = {
			idModule: this.$stateParams.idModule,
			acaUnit: this.$stateParams.acaUnit,
			workplanId: (plansId.length > 0) ? plansId : undefined,
			stateId: (this.state != null) ? this.state.id_code : undefined
		}
		let urls = {
			"2": "strategicTracking.strategicTrackingTeacher", 
			"3": "strategicTracking.strategicTrackingAcadManagement", 
			"4": "strategicTracking.strategicTrackingExtension", 
			"5": "strategicTracking.strategicTrackingConsolidation", 
			"6": "strategicTracking.strategicTrackingInvestigation", 
			"0": "strategicTracking.strategicTrackingGlobalView", 
		}
		this.$state.go(urls[params.idModule], params)
	}

	defineUiGrid(uiGridConstants) {
		this.gridOptions = {
			enableRowSelection: true,
			enableRowHeaderSelection: false,
			multiSelect: false,
			modifierKeysToMultiSelect: false,
			noUnselect: true,
			enableFiltering: true,
			data: [],  
			columnDefs: [{
					name: 'Profesor',
					displayName: 'Profesor',
					field: 'ds_teacher',
					width: "46%", 
					enableGridMenu: false,
					enableHiding: false,
					enablePinning: false,
					enableColumnMenu: false,
					enableSorting: true,
					cellClass: 'text-xs',
					headerCellClass: 'font-normal text-xs',
					filter: {
						term: '',
						type: uiGridConstants.filter.CONTAINS
					},
					cellTemplate:   '<div class="text-left ui-grid-cell-contents">' +
										'<span>{{row.entity.ds_teacher}} ' + 
											'<small ng-if="row.entity.is_new == 1" class="badge bg-warning"> Nuevo</small>'+
										'</span>' +
									'</div>'
				},
				{
					name: 'Unidad Académica',
					displayName: 'Unidad Académica',
					field: 'ds_acadunit',
					width: "30%", 
					enableGridMenu: false,
					enableHiding: false,
					enablePinning: false,
					enableColumnMenu: false,
					enableSorting: true,
					cellClass: 'text-xs',
					headerCellClass: 'font-normal text-xs',
					filter: {
						term: '',
						type: uiGridConstants.filter.CONTAINS
					}
				},
				{
					name: 'Cant. Actividades',
					displayName: 'Cant. Actividades',
					field: 'cantidad',
					width: "12%", 
					enableGridMenu: false,
					enableHiding: false,
					enablePinning: false,
					enableColumnMenu: false,
					enableSorting: true,
					cellClass: 'text-xs',
					headerCellClass: 'font-normal text-xs',
					filter: {
						term: '',
						type: uiGridConstants.filter.CONTAINS
					}
				},
				{
					name: 'Ver Seguimiento',
					displayName: 'Ver Seguimiento',
					field: 'id_teacher',
					width: "12%", 
					enableGridMenu: false,
					enableHiding: false,
					enablePinning: false,
					enableColumnMenu: false,
					enableSorting: true,
					cellClass: 'text-xs',
					headerCellClass: 'font-normal text-xs',
					headerCellTemplate: 	'<div class="ui-grid-cell-contents text-center ui-grid-header-cell-primary-focus">' +
												'<span class="ui-grid-header-cell-label ng-binding">Ver Seguimiento</span>' +
											'</div>',
					cellTemplate:   '<div class="text-center ui-grid-cell-contents">' +
										'<label class="md-check">' +
											'<a ng-click="grid.appScope.cDetails.goToDetails(row.entity)" class="underscore text-azul">ver Detalles</a>' +
										'</label>' +
									'</div>'
				}
			],
			onRegisterApi: (gridApi) => {
				this.gridApi = gridApi;
			}
		}

	}
}

chartsDetailsCtrl.$inject = ['$scope', '$state', '$stateParams', 'ngNotify', '$timeout', 'UserInfoConstant', 'strategicTrackingListSrv', 'uiGridConstants', '$location', '$cookies'];


// WEBPACK FOOTER //
// ./src/app/u-faculty/strategicTracking/chartsDetails/chartsDetailsCtrl.js